<template>
    <div>
        <register-steps
            :steps="{1:'Gegevens',2:'Aan de slag!'}"
            totalAnswered="33"
            currentStep="1"
        />

        <div class="sd-title medium" style="margin-bottom: 20px;">
            <span class="steps">1/3</span>
            Aanmelden
        </div>

        <div class="sd-col-12 step-question mb-3">
            <strong class="sd-title mini right-line">
                <span class="title-text"><svg-icon icon="smiley" /> Type onderwijs</span>
            </strong>
            <label for="form-name" style="margin-top: 5px; margin-bottom: 5px;">
                Voor welke type onderwijs zoek je een invalkracht?<span class="required">*</span>
            </label>

            <div class="custom-control custom-radio">
                <input
                    type="radio"
                    class="custom-control-input"
                    value="1"
                    id="primary-school"
                    name="education-type"
                    :checked="value.sub_branch === '1'"
                    @change="update('sub_branch', '1')"
                />
                <label class="custom-control-label" for="primary-school">
                    Basisonderwijs
                </label>
            </div>

            <div class="custom-control custom-radio">
                <input
                    type="radio"
                    class="custom-control-input"
                    value="2"
                    id="secondary-school"
                    name="education-type"
                    :checked="value.sub_branch === '2'"
                    @change="update('sub_branch', '2')"
                />
                <label class="custom-control-label" for="secondary-school">
                    Voortgezet onderwijs
                </label>
            </div>
        </div>

        <div class="input-row">
            <div class="sd-input sd-col-12">
                <strong class="sd-title mini right-line">
                    <span class="title-text"><svg-icon icon="school" /> School gegevens</span>
                </strong>
            </div>

            <div class="sd-input sd-col-12">
                <label for="form-name">Naam school/stichting <span class="required">*</span></label>
                <input
                    id="form-name"
                    type="text"
                    class="form-control"
                    autocomplete="nope"
                    :value="value.name"
                    @input="update('name', $event.target.value)"
                    placeholder="Naam school/stichting"
                    required
                />

                <span class="extra-info text-left mt-2">
                    <svg-icon icon="information" />
                    Let op: de naam van de organisatie kan geen leestekens bevatten
                  </span>

            </div>
        </div>

        <div class="input-row">
            <div class="sd-input sd-col-12">
                <label for="form-email">E-mailadres<span class="required">*</span></label>
                <input
                    id="form-email"
                    type="email"
                    class="form-control"
                    autocomplete="nope"
                    :value="value.email"
                    @input="update('email', $event.target.value)"
                    placeholder="E-mailadres"
                    required
                />
            </div>
        </div>

        <div class="input-row">
            <div class="sd-input sd-col-12">
                <label for="form-email">Factuur e-mailadres<span class="required">*</span></label>
                <input
                    id="form-email"
                    type="email"
                    class="form-control"
                    autocomplete="nope"
                    :value="value.invoice_email"
                    @input="update('invoice_email', $event.target.value)"
                    placeholder="Factuur e-mailadres"
                    required
                />
            </div>
        </div>

        <div class="input-row">
            <div class="w-square-icon sd-input sd-col-12">
                <label for="form-password">Wachtwoord<span class="required">*</span></label>
                <div class="input-container">
                    <input
                        id="form-password"
                        :type="!pass1 ? 'password' : 'text'"
                        class="form-control"
                        :value="value.password"
                        @input="update('password', $event.target.value)"
                        placeholder="Wachtwoord"
                        autocomplete="nope"
                        required
                    />
                    <div
                        class="icon-wrapper eye position-absolute align-self-center"
                        v-on:click="pass1 = false"
                        v-if="pass1"
                        v-ripple="'rgba(255, 255, 255, 0.35)'"
                    >
                        <span><svg-icon icon="eye" /></span>
                    </div>
                    <div
                        class="icon-wrapper eye shown position-absolute align-self-center"
                        v-on:click="pass1 = true"
                        v-else
                        v-ripple="'rgba(255, 255, 255, 0.35)'"
                    >
                        <svg-icon icon="eye_hidden" />
                    </div>
                </div>
            </div>
        </div>

        <div class="input-row">
            <div class="w-square-icon sd-input sd-col-12">
                <label for="form-confirm-password">Bevestig wachtwoord<span class="required">*</span></label>
                <div class="input-container">
                    <input
                        id="form-confirm-password"
                        :type="!pass2 ? 'password' : 'text'"
                        class="form-control"
                        :value="value.password_confirmation"
                        @input="update('password_confirmation', $event.target.value)"
                        placeholder="Bevestig wachtwoord"
                        autocomplete="nope"
                        required
                    />
                    <div
                        class="icon-wrapper eye position-absolute align-self-center"
                        v-on:click="pass2 = false"
                        v-if="pass2"
                        v-ripple="'rgba(255, 255, 255, 0.35)'"
                    >
                        <span><svg-icon icon="eye" /></span>
                    </div>
                    <div
                        class="icon-wrapper eye shown position-absolute align-self-center"
                        v-on:click="pass2 = true"
                        v-else
                        v-ripple="'rgba(255, 255, 255, 0.35)'"
                    >
                        <svg-icon icon="eye_hidden" />
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
export default {
    props: {
        value: {
            type: Object,
            default: () => ({})
        },
    },
    data() {
        return {
            pass1: false,
            pass2: false,
        }
    },
    methods: {
        update(field, val) {
            this.$emit('input', {
                ...this.value,
                [field]: val
            })
        }


    }
}
</script>

<style scoped>

</style>